@if (shouldShowPriceChangeInfo) {
  <div class="payment-checkout__price-change-notice">
    <img src="../../../assets/svg/warning-icon.svg" class="payment-checkout__price-change-notice-icon" alt="" />
    <p class="payment-checkout__price-change-notice-text">
      @if (isPremiumPlusDowngradeInfo) {
        {{ "CONFIRM_TAX_RETURN.PRICE_CHANGE_INFO.PREMIUM_PLUS_TO_PREMIUM" | translate }}
      } @else {
        {{ "CONFIRM_TAX_RETURN.PRICE_CHANGE_INFO.PREMIUM_PRICE_CHANGED" | translate }}
      }
    </p>
  </div>
}
@if (paymentConfirmation || statementPaymentAmount) {
  <div class="payment-checkout__row">
    <div class="payment-checkout__order_wrap">
      <ul class="payment-checkout__order_list">
        @if (statement?.isPremiumPackage && statementPaymentAmount && !statementPaymentAmount.shouldBeIndividualService) {
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.ADVISER_FEE" | translate }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ statementPaymentAmount.taxAdvisorFee | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.TAXANDO_FEE" | translate }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ statementPaymentAmount.taxandoFee | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.NET_SUM" | translate }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ statementPaymentAmount.premiumNet | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.VAT_PLUS" | translate }} {{ vatPercentFormatted }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ statementPaymentAmount.taxandoFeeVat | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title bolded">
              {{ "PAYMENT_INFO.SUMMARY" | translate }}
            </div>
            <div class="payment-checkout__order_list_value bolded">
              {{ (paymentConfirmation?.amount_total || statementPaymentAmount.premiumAmountTotal) | number: "1.2-2" }}
              {{ currencySymbol }}
            </div>
          </li>
        } @else if (statementPaymentAmount) {
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.ORDER_LIST_STANDARD_NETTO" | translate }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ statementPaymentAmount.standardNet | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.ORDER_LIST_VAT" | translate }} ({{ vatPercentFormatted }})
            </div>
            <div class="payment-checkout__order_list_value">
              {{ statementPaymentAmount.standardAmountVat | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title bolded">
              {{ "PAYMENT_INFO.SUMMARY" | translate }}
            </div>
            <div class="payment-checkout__order_list_value bolded">
              {{ (paymentConfirmation?.amount_total || statementPaymentAmount.standardAmountTotal) | number: "1.2-2" }}
              {{ currencySymbol }}
            </div>
          </li>
        } @else if (paymentConfirmation) {
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.NET_SUM" | translate }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ paymentConfirmation.amount_netto | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title">
              {{ "CHECKOUT.VAT_PLUS" | translate }} {{ vatPercentFormatted }}
            </div>
            <div class="payment-checkout__order_list_value">
              {{ paymentConfirmation.amount_vat | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
          <li>
            <div class="payment-checkout__order_list_title bolded">
              {{ "PAYMENT_INFO.SUMMARY" | translate }}
            </div>
            <div class="payment-checkout__order_list_value bolded">
              {{ paymentConfirmation.amount_total | number: "1.2-2" }} {{ currencySymbol }}
            </div>
          </li>
        }
      </ul>
    </div>
    @if (paymentConfirmation?.is_percentage_payment) {
      <div class="payment-checkout__percentage-info">
        <span class="percentage-text">{{ "PAYMENT_INFO.PERCENTAGE_VALUE" | translate }}</span>
        <span class="info-text">{{ "PAYMENT_INFO.PERCENTAGE_INFO" | translate }}</span>
      </div>
    }
  </div>
}
